<template>
    <figure
        v-editable="blok"
        class="article-image"
    >
        <NuxtImg
            v-if="blok.image.filename"
            :src="blok.image.filename"
            :alt="blok.image.alt"
            class="article-image__image"
            :class="[
                blok.objectFit && `article-image__image--${blok.objectFit}`,
                blok.aspectRatio && `article-image__image--aspect-${blok.aspectRatio}`,
            ]"
            :width="dims?.width"
            :height="dims?.height"
            format="auto"
            loading="lazy"
            sizes="xs:100vw sm:100vw md:100vw lg:640px"
        />

        <a
            v-if="blok.downloadable"
            class="article-image__download"
            :href="blok.image.filename"
            download
        >
            <Icon name="tabler:download" />
        </a>
        <figcaption
            v-if="text"
            class="article-image__text"
            v-html="text"
        />
    </figure>
</template>

<script setup>
import storyblokImageSize from '~/helpers/storyblokImageSize'

const { blok } = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
})

// width/height at the intrinsic ratio: the transform only downscales (no
// `fit`, so Cloudflare never crops) and the attrs reserve layout before the
// image loads (CLS). The visible crop is owned by CSS (fixed heights /
// `article-image__image--aspect-*` modifiers in article.scss).
const dims = computed(() => storyblokImageSize(blok.image.filename))

// Computed (not a setup-scope snapshot) so the Visual Editor's live content
// patches re-render the caption.
const text = computed(() => renderRichText(blok.description)
    .replaceAll('target="_self"', 'target="_blank" rel="license nofollow"'))
</script>

<style lang="scss">
@use 'article-image';
</style>
